import { faChevronRight } from "@fortawesome/pro-solid-svg-icons";
import { useImagePreviewHandlers, useImagePreviewState } from "../../image-preview-context";
import { Tool } from "./tool";
import { ToolboxToolProps } from "./toolbox.types";
import { Group } from "../../../group";
import { Kbd } from "@mantine/core";

/**
 * Next tool for the ImagePreview toolbox. Switches to the next image in the gallery.
 */
export const Next = (props: ToolboxToolProps) => {
    const handlers = useImagePreviewHandlers();
    const { images } = useImagePreviewState();
    if (images.length <= 1) return null;

    return (
        <Tool
            icon={faChevronRight}
            label={
                <Group>
                    Next <Kbd>→</Kbd>
                </Group>
            }
            onClick={handlers.next}
            {...props}
        />
    );
};
